const generalActionTypes = {
    START_GET_APP_VERSION: 'START_GET_APP_VERSION',
    GET_APP_VERSION_SUCCESS: 'GET_APP_VERSION_SUCCESS',
    GET_APP_VERSION_FAILURE: 'GET_APP_VERSION_FAILURE',

    START_GET_LANDING_PAGE_URL: 'START_GET_LANDING_PAGE_URL',
    GET_LANDING_PAGE_URL_SUCCESS: 'GET_LANDING_PAGE_URL_SUCCESS',
    GET_LANDING_PAGE_URL_FAILURE: 'GET_LANDING_PAGE_URL_FAILURE',
}

export default generalActionTypes;